// extracted by mini-css-extract-plugin
export var sbShowMain = "menuIcon-module--sb-show-main--1xGZS";
export var menuIcon = "menuIcon-module--menuIcon--3sgIO";
export var open = "menuIcon-module--open--AhKgO";